import { apiClient } from "../api/apiclient";

export const getAllInstructions = (token) =>
    apiClient.get("/instructions/all", {
        headers: { Authorization: `Bearer ${token}` },
});
